angular.module('agreements')
    .controller('AgreementEditController', function (toastr, $scope, $rootScope, $uibModalInstance, Agreement, AgreementConst, data, AgreementService, FilesSimpleUploadService, Principal) {
        this.AgreementService = AgreementService
        this.$onInit = () => {
            this.item = data
            this.item.currency = this.item.currency || 'PLN'
            this.canEditConfidential = Principal.hasAnyAuthority(['ROLE_CONTRACT_CONFIDENTIAL'])
            if (this.item.id !== null) {
                Agreement.get({id: this.item.id}).$promise.then(result => this.item = result)
            }
            if(this.item.type === 'ANNEX'){
                this.subtypes = ['ANNEX', 'VARIATION_ORDER_REQUEST', 'SETTLEMENT']
            }
            this.isNotAnnex = ['AGREEMENT', 'ORDER', 'OFFER'].includes(this.item.type)
            this.valueTypes = ['ESTIMATED', 'FLAT_RATE' ]
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.onSubcontractorStatementsEnabledChange = () => {
            if (!this.item.subcontractorStatementsEnabled) {
                this.item.subcontractorStatementsRequired = false
            }
        }
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Agreement.update(this.item).$promise
            } else {
                promise = Agreement.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(AgreementConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
        this.selectParent = () => {
            AgreementService.select().then(agreement => {
                if (this.item.uid === agreement.uid) {
                    toastr.error("Umowa bazowa musi być inna niż edytowana")
                    return
                }
                this.item.parent = agreement
            })
        }
        this.uploadAttachments = () => {
            FilesSimpleUploadService.open({})
                .then(result => {
                    if (!angular.isArray(result)) {
                        toastr.error("Nie udało się przesłać pliku")
                        return
                    }
                    this.item.attachments = this.item.attachments.concat(result)
                })
        }
    })
